import { createContext, useState } from "react";
import { getViewport } from "./services/StyleUtilites";

export const UserContext = createContext();
